{
  "EmailNotifications": "Notificaciones por email",
  "NotificationDescription": "Envíame notificaciones para:",
  "MyActivityUpdateTitle": "Novedades sobre mis actividades",
  "MyActivityDescription": "Novedades diarias de comentarios, notas, o respuestas en mis proyectos, posts o comentarios",
  "Daily": "Diariamente",
  "Weekly": "Semanalmente",
  "Monthly": "Mensualmente",
  "None": "Ninguna",
  "HubActivityTitle": "Novdedades sobre la actividad en Hub",
  "HubActivityDescription": "Resumen semanal de la actividad de la comunidad en mis Hubs",
  "MarketingEmailTitle": "Marketing emails",
  "MarketingEmailDescription": "Rebelbase puede enviar a los usuarios emails para pedir su opinión con una encuesta o para otros fines de marketing",
  "Yes": "Sí",
  "No": "No",
  "Save": "Guardar"
}
